import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { idexTheme } from './theme';
import Layout from './components/Layout';
import { AuthProvider } from './auth/AuthContext';
import LoginDialog from './auth/LoginDialog';
import Schedule from './pages/Schedule';
import Main from './pages/Main';
import Exports from './pages/Exports';
import Admin from './pages/Admin';
import Tem from './pages/Tem';
import Info from './pages/Info';
import NotFound from './pages/NotFound';

function App() {
  return (
    <ThemeProvider theme={idexTheme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <LoginDialog />
          <Layout>
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/main" element={<Main />} />
              <Route path="/exports" element={<Exports />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/tem" element={<Tem />} />
              <Route path="/info" element={<Info />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
